
export const GET_EMPLOYEE_INFORMATION = "GET_EMPLOYEE_INFORMATION";


export const ACCOUNT_ENTRIES_COMPANIES = "ACCOUNT_ENTRIES_COMPANIES";
export const ACCOUNT_ENTRIES_SCHEME = "ACCOUNT_ENTRIES_SCHEME";
export const ACCOUNT_ENTRIES_PERIODS = "ACCOUNT_ENTRIES_PERIODS";
export const ACCOUNT_ENTRIES_VFLEX_CONFIGURATION = "ACCOUNT_ENTRIES_VFLEX_CONFIGURATION";